import { render, staticRenderFns } from "./CreditoDetail.vue?vue&type=template&id=63770efe"
import script from "./CreditoDetail.vue?vue&type=script&lang=js"
export * from "./CreditoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports